import dayjs from 'dayjs';

// True when the project's end date has already passed (strictly before today),
// regardless of the project's status.
export const isProjectEndDatePassed = (project) =>
  Boolean(project?.endAt) && dayjs(project.endAt).isBefore(dayjs(), 'day');

// A project counts as "ended" when its end date has passed AND it is not
// archived. Archived status wins: archived projects stay in the archived
// section, not the ended section.
export const isProjectEnded = (project) =>
  isProjectEndDatePassed(project) && project.status !== 'ARCHIVED';
